import React, { useContext, useMemo } from 'react'
import {
  checkSpecialWeek,
  createVenueLocation,
  getShortWeekName,
  isIncompleteChampionship,
} from '../../../../Utils'
import { HeaderActions } from './HeaderActions/HeaderActions'
import { SpecialWk, WKHeader } from './weekStyles'
import type { EventGQL } from '../../../../Api'
import { colors } from '../../../../Components/consts'
import { SeasonContext } from '../../../../Context'
import { Head } from '../../../../Components/Typography/Text.styles'

type HeaderParams = {
  week: string
  events: EventGQL[]
}

export const WeekHeader: React.FC<React.PropsWithChildren<HeaderParams>> = ({
  week,
  events,
}) => {
  const { incompleteMarkets } = useContext(SeasonContext)!
  const specialWeek = events.length < 1 ? null : checkSpecialWeek(events[0], true)
  const isChampSeriesWeek =
    events.length > 0 && events[0].seasonSegment === 'champseries'

  const checkEvents = () => {
    const pendingEvent = events.find((ev) => ev.eventStatus === 0)
    if (!pendingEvent) return false
    if (!events[0].location) return false
    return true
  }

  const wkName = useMemo(() => {
    if (events.length === 0) return null
    if (events[0].seasonSegment === 'post') return null
    return getShortWeekName(events[0])
  }, [events])

  if (events.length === 0) {
    return <div />
  }

  return (
    <>
      <WKHeader>
        <div className="gameInfo">
          {!isChampSeriesWeek && wkName && (
            <div className="gameWeek">
              <Head textColor={colors.white}>{`${wkName}`}</Head>
            </div>
          )}
          {events && (
            <div className="weekendInfoCon">
              <h2>
                {isIncompleteChampionship(
                  events[0]?.slugname,
                  events[0]?.week,
                  incompleteMarkets
                )
                  ? 'TBD'
                  : createVenueLocation(events[0]?.location, events[0]?.seasonSegment)}
              </h2>
              <p>
                {isIncompleteChampionship(
                  events[0]?.slugname,
                  events[0]?.week,
                  incompleteMarkets
                )
                  ? 'TBD'
                  : events[0]?.venue}
              </p>
            </div>
          )}
        </div>
        {checkEvents() && <HeaderActions week={week} events={events} />}
      </WKHeader>
      {specialWeek && (
        <SpecialWk>
          <h3 className="hcTitle">{specialWeek}</h3>
        </SpecialWk>
      )}
    </>
  )
}
